export default __webpack_public_path__ + "assets/images/5a89e4b1895807706191cbf9ef21b294.png";